import React from 'react';

let characterInterval:any;

interface IState {
  activeClass?:any;
}
interface IProps {
  active?:any;
}

class HolidayGrinch extends React.Component<IProps> {
  public state: IState;

  constructor(props: IProps) {
      super(props);
      this.state={
        activeClass:""
      };
  }
  public componentDidMount = () =>{
    this.startGame();
  }
  public componentWillUnMount = () =>{
    clearInterval(characterInterval);
  }
  public startGame = () => {
    characterInterval = setInterval(()=>this.positionGrinch(), 20000);
  }
  public positionGrinch = () =>{
    this.setState({
      activeClass:"active",
    },()=>{
      setTimeout(()=>{
        this.setState({
          activeClass:"gone"
        })
      },8000);
    })
  }

  public grinchClick = () =>{
    let elem = document.createElement('div');
    if(elem){
      elem.setAttribute('id','freezer');
    }
    document.body.appendChild(elem);
    setTimeout(()=>{
      let elem = document.getElementById('freezer');
      if(elem && elem.classList){
        elem.classList.add('active');
      }
      let cracker = document.createElement('div');
      if(cracker){
        cracker.setAttribute('id','cracker');
      }
      document.body.appendChild(cracker);
       let body = document.getElementsByTagName('body')[0];
       body.classList.add('earthquake');
       setTimeout(()=>{
         var audio = new Audio('https://assets.hosports.com/holiday/scream.mp3');
         if(audio){
           audio.play();
         }
       },1000);
      setTimeout(()=>{
        var audio = new Audio('https://assets.hosports.com/holiday/glass-break.mp3');
        if(audio){
          audio.play();
        }
        let elem = document.getElementById('cracker');
        if(elem && elem.classList){
          elem.classList.add('active');
        }

        let body = document.getElementsByTagName('body')[0];
        if(body && body.classList){
          body.classList.add('active');
          body.classList.remove('earthquake');
        }

        setTimeout(()=>{
          let cracker = document.getElementById('cracker');
          if(cracker){
            cracker.remove();
          }
          let elem = document.getElementById('freezer');
          if(elem){
            elem.remove();
          }
        },3750);
      },2500);
    },100);
  }

  public render(): JSX.Element {
    return(
      <div
        id="grinch"
        onClick={this.grinchClick}
        className={this.state.activeClass}>
        <img
          src={'https://assets.hosports.com/holiday/grinch.png'}
          className="shakeY full-width"
        />
      </div>
    )
  }
}

//@ts-ignore
export default HolidayGrinch;
